import { toast } from 'sonner';

export const showToast = {
  success: (message: string) => {
    return toast.success(message, { classNames: { icon: 'text-teal-600' } });
  },
  error: (message: string) => {
    return toast.error(message, { classNames: { icon: 'text-red-600' } });
  },
  warning: (message: string) => {
    return toast.warning(message, { classNames: { icon: 'text-yellow-600' } });
  },
  info: (message: string) => {
    return toast.info(message, { classNames: { icon: 'text-blue-600' } });
  },
  // Toast personalizado com opções adicionais
  custom: (message: string, options?: object) => {
    return toast(message, options);
  },
};
